import { Drawer, IconButton } from "@mui/material";
import CloseIcon from "assets/CloseIcon";
import Backbutton from "assets/backbutton";
import Feedback from "components/common/Feedback";
import { clearFilters } from "components/common/Filters/Filters.slice";
import Typography from "components/common/Typography";
import { resetAllFilters } from "components/features/AboveProperty/AboveProperty.slice";
import { useTranslate } from "hooks/useTranslate";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { setSelectedList, updateRecentlyViewedData } from "../CorpUser.Slice";
import CorpView from "../CorpView";
import { CreateListDialog } from "./Dialogs/CreateListDialog";
import LeftWrapper from "./LeftWrapper";
import "./MyLists.scss";

const MyLists = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const location = useLocation();
  const navigate = useNavigate();
  const savedFiltersAndLists = useAppSelector((state) => state.filters.savedFilter);
  const selectedList = useAppSelector((state: any) => state.CorpDashboard.myListsSelected.selectedList);
  const listCategory = useAppSelector((state: any) => state.CorpDashboard.myListsSelected.listCategory);
  const navigatedList = useAppSelector((state: any) => state.CorpDashboard.myListsSelected.navigatedList);
  const [open, setOpen] = useState<boolean>();

  useEffect(() => {
    if (selectedList?.id) {
      dispatch(
        updateRecentlyViewedData({
          myList: [
            {
              id: `${selectedList?.id}`,
              myListType: listCategory
            }
          ]
        })
      );
    }
  }, [selectedList]);

  useEffect(() => {
    if (!isEmpty(location.state)) setOpen(location?.state?.toggleOpen);
  }, [location]);

  useEffect(() => {
    dispatch(resetAllFilters());
    if (isEmpty(selectedList)) {
      dispatch(clearFilters({ eliminateMyList: true, skipView: true }));
      dispatch(setSelectedList(savedFiltersAndLists["bookmarked"][0]));
    }
  }, [selectedList]);

  useEffect(() => {
    if (navigatedList) {
      if (location?.state?.fromDashboard) {
        dispatch(clearFilters({ eliminateMyList: true }));
        navigate(location.pathname, { replace: true });
      }
      const selectedMyList = savedFiltersAndLists[listCategory]?.find(
        (el: any) => el?.id?.toString() === navigatedList?.id?.toString()
      );
      if (selectedMyList) dispatch(setSelectedList(selectedMyList));
    }
  }, [navigatedList]);

  return (
    <>
      <Feedback form="renameDynamicList" />
      <div className="my-list-corp-component">
        {" "}
        <Typography variant={"h3"} showBold className="my-list-corp-heading">
          {translate("common.myListsLabel")}
        </Typography>
        <div className="my-list-corp-desktop"></div>
        <div className="my-list-corp-back-text" onClick={() => setOpen(true)}>
          {" "}
          <Backbutton color={tokens.Text.General.Color}></Backbutton>
          <Typography variant={""} showBold>
            {translate("common.allListsLabel")}
          </Typography>
        </div>
        <div className="my-list-corp-container">
          <div className="my-list-corp-desktop">
            <LeftWrapper open={open} setOpen={setOpen} />
          </div>

          <div className="my-list-corp-right-wrapper">
            {!isEmpty(selectedList) && (
              <CorpView
                selectedListType={listCategory}
                selectedList={selectedList}
                label={selectedList?.name}
                selectedListFilters={listCategory === "dynamic" ? selectedList : {}}
                view="myList"
              />
            )}
          </div>
        </div>
        <div className="my-list-corp-mobile">
          <Drawer
            anchor={"left"}
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{
              sx: {
                justifyContent: "space-between",
                width: "100%",
                padding: "16px",
                backgroundColor: "#F6F5F3"
              }
            }}
          >
            <div className="my-list-corp-component">
              <div className="my-list-corp-close-icon">
                <Typography variant={"body2"} className="my-list-corp-heading">
                  {translate("common.myListsLabel")}
                </Typography>
                <IconButton onClick={() => setOpen(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
              {!open && (
                <Typography variant={"h3"} showBold className="my-list-corp-heading">
                  {translate("common.myListsLabel")}
                </Typography>
              )}
              <LeftWrapper open={open} setOpen={setOpen} />
            </div>
          </Drawer>
        </div>
      </div>

      <CreateListDialog />
    </>
  );
};
export default React.memo(MyLists);
